import { FbaTransportV2024ItemEligibility } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import type { operations } from '@/api/generated/openapi';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export type FetchEligibilityQuery = operations['fetch-fba-transport-v2024-item-eligibility']['parameters']['query'];
export type FetchEligibilityResponse = operations['fetch-fba-transport-v2024-item-eligibility']['responses']['200']['content']['application/json'];
export type FetchEligibilityFromAmazonQuery = operations['fetch-fba-transport-v2024-item-eligibility-from-amazon']['parameters']['query'];
export type FetchEligibilityFromAmazonResponse = operations['fetch-fba-transport-v2024-item-eligibility-from-amazon']['responses']['200']['content']['application/json'];
export type ItemEligibilityRaw = FetchEligibilityResponse['data'][number];

export function toItemEligibility(raw: ItemEligibilityRaw): FbaTransportV2024ItemEligibility {
    return {
        id: raw.id,
        channelId: raw.channel_id,
        asin: raw.asin,
        program: raw.program,
        isEligible: raw.is_eligible,
        ineligibilityReasons: raw.ineligibility_reasons,
    };
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { fetchEligibility: (channelId: number, asins: string[]) => Promise<FbaTransportV2024ItemEligibility[]>; fetchEligibilityFromAmazon: (channelId: number, asin: string) => Promise<FbaTransportV2024ItemEligibility | null>; } => ({
    /**
     * Fetch cached eligibility records from the database (no Amazon API call)
     */
    fetchEligibility: async (channelId: number, asins: string[]): Promise<FbaTransportV2024ItemEligibility[]> => {
        const query: FetchEligibilityQuery = { channel_id: channelId, asins };
        const response = await axios.get<FetchEligibilityResponse>('/api/fba-transport/v2024/item-eligibility', { params: query });

        return response.data.data.map(toItemEligibility);
    },

    /**
     * Fetch eligibility for a single ASIN from Amazon (rate limited: 1 per second)
     */
    fetchEligibilityFromAmazon: async (channelId: number, asin: string): Promise<FbaTransportV2024ItemEligibility | null> => {
        const query: FetchEligibilityFromAmazonQuery = { channel_id: channelId, asin };
        const response = await axios.get<FetchEligibilityFromAmazonResponse>('/api/fba-transport/v2024/fetch-item-eligibility', { params: query });

        return response.data.data === null ? null : toItemEligibility(response.data.data);
    },
});
